function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 24)
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.sp_hour').html(hours)
      $('.sp_minute').html(minutes)
      $('.sp_second').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })
    var swiper = new Swiper('.mySwiper', {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      loop: true,
      autoplay: {
        delay: 4000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })

    new Swiper('.mySwiper2', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      freeMode: true,
      speed: 2000, //匀速时间
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
     let prods = window.product
  function getCur() {
    let color = $('#color div.active').attr('data-val')
    let qty = $('#qty div.active').attr('data-val')
    return prods.filter(
      item => item.option1 == color && item.option2 == qty
    )[0]
  }
  function changePrice() {
    let num = $('#calcNumber').val()
    let price = (getCur().price / 100).toFixed(2)
    let compare = (getCur().compare_at_price / 100).toFixed(2)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    $('#new').html(price)
    $('#old').html(compare)
    let off_font =
      100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
    $('#price_off').html(`${off_font}`)
  }
  $('.sp-btn-style').click(function () {
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
  })
    //加减
    $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
      }
      var number = Number($('#calcNumber').val())
     changePrice()
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
      var number = Number($('#calcNumber').val())
    changePrice()
    })
    var textArr = ['01# Brown', '02 Gray Brown', '03# Black','01# Marrone+03# Nero','02# Marrone Chiaro + 03# Nero',"02# Marrone Chiaro +  01# Marrone","01# Marrone*2 + 03# Nero*3","02# Marrone Chiaro*2 + 03# Nero*3","02# Marrone Chiaro*2 + 01# Marrone*3"]
    var imgArr = [
      'https://cdn.shopify.com/s/files/1/0624/7687/7889/files/20240929-pro-1.png',
      'https://cdn.shopify.com/s/files/1/0624/7687/7889/files/20240929-pro-2.png',
      'https://cdn.shopify.com/s/files/1/0624/7687/7889/files/20240929-pro-3.png',
      'https://cdn.shopify.com/s/files/1/0624/7687/7889/files/20250911-pro1.png',
      'https://cdn.shopify.com/s/files/1/0624/7687/7889/files/20250911-pro2.png',
      'https://cdn.shopify.com/s/files/1/0624/7687/7889/files/20250911-pro3.png',
      'https://cdn.shopify.com/s/files/1/0624/7687/7889/files/20250911-pro4.png',
      'https://cdn.shopify.com/s/files/1/0624/7687/7889/files/20250911-pro5.png',
      'https://cdn.shopify.com/s/files/1/0624/7687/7889/files/20250911-pro6.png',
            'https://cdn.shopify.com/s/files/1/0624/7687/7889/files/61c1dbc4a1c67486180ae4c81acb0e05.png?v=1757573651',
      'https://cdn.shopify.com/s/files/1/0624/7687/7889/files/c70aa1812383ec846bfed67f68b79ab2.png?v=1757573651',

      'https://cdn.shopify.com/s/files/1/0624/7687/7889/files/a4df05ccc7b8a8c4ad14e4a389f9d351.png?v=1757573650',
       'https://cdn.shopify.com/s/files/1/0624/7687/7889/files/2_3_80c2d3cb-27b6-4c40-8292-effa9d935e8b.png?v=1757573650',
      'https://cdn.shopify.com/s/files/1/0624/7687/7889/files/2_3_8df70e20-f6ae-458c-b483-d688b66140b5.png?v=1757573650',

           'https://cdn.shopify.com/s/files/1/0624/7687/7889/files/2_3.png?v=1757573650',
    ]
    // style选项
    let typeOptions = $('#color .option')

    // 切换选项
    typeOptions.click(function () {
      $(this).addClass('active').siblings().removeClass('active')
      changeSale()
      changePrice()
    })
    $('#qty .option').click(function () {
      $(this).addClass('active').siblings().removeClass('active')
      changeSale()
    })
    function changeSale() {
      let index1 = $('#color .option.active').index()
      let index2 = $('#qty .option.active').index()
      if (index2 == 1){
        $('.free-text').show()
        if(index1 == 0){
            $('.free-text').css("right","100px")
            $('.free-text').css("bottom","68px")
        }else if(index1 == 1){
            $('.free-text').css("right","194px")
            $('.free-text').css("bottom","68px")
        }else{
            $('.free-text').css("right","161px")
            $('.free-text').css("bottom","59px")
        }
      }else if (index2 == 2){
        $('.free-text').show()
        if(index1 == 0){
            $('.free-text').css("right","113px")
            $('.free-text').css("bottom","68px")
        }else if(index1 == 1){
            $('.free-text').css("right","113px")
            $('.free-text').css("bottom","59px")
        }else{
            $('.free-text').css("right","113px")
            $('.free-text').css("bottom","59px")
        }
      } else {
        $('.free-text').hide();
      }
      $('.top-product span').html(textArr[index1])
    let index = index1 + index2*3
      $('.top-product img').attr('src', imgArr[index])
    }
    addCart()
    function addCart() {
      // 加入购物车
      $('#addCart').click(function () {
        // do something here
        // var number = Number($('.sp-cart #cardNum').html()) + 1
        // $('.sp-cart #cardNum').html(number)
         var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
            $('#cardNum').html(result.item_count)
          })
        },
        dataType: 'json',
      })
        var img = $('.top-product img')
        var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        $('.sp-part5').append(flyer)
        $('.clone').css({
          width: img.width(),
          height: img.height(),
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '99',
        })
        var offset = $('.sp-cart')[0].getBoundingClientRect()
        $('.sp-cart').addClass('shake')
        setTimeout(() => {
          $('.sp-cart').removeClass('shake')
        }, 1000)
        let finish = $('.sp-cart')
        $('.clone').animate(
          {
            top: finish[0].offsetTop + 117,
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
          }
        )
      })
    }
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach(subArray => {
        subArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach(url => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    preloadImages(imgArr)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop =
          targetElement.offsetTop -
          $('.time-part').height() -
          $('.sp-header-top').height()
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
